import BoxContainer from "./BoxContainer";
import Box from "@mui/material/Box";
import BoxHeading from "./BoxHeading";
import { Trans } from "react-i18next";
import Button from "@mui/material/Button";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import useRoutes, { getLinkComponentAttributes } from "../../hooks/useRoutes";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../../providers/AuthProvider";

const useStyles = makeStyles((theme) => ({
  bottomContainer: {
    marginTop: theme.spacing(4),
  },
  heading: {
    fontSize: "20px",
    color: theme.palette.primary.dark + " !important",
    margin: 0,
  },
  loggedInText: {
    textAlign: "center",
  },
}));

const UserLoggedInBox = () => {
  const classes = useStyles();
  const routes = useRoutes();
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down("sm"));
  const { user } = useAuth();

  const myAccountProps = getLinkComponentAttributes(
    "products.packages",
    routes,
  );

  return (
    <BoxContainer className={classes.bottomContainer}>
      <Box display="flex" alignItems="center">
        <Box className={classes.loggedInText} flexGrow={1}>
          <BoxHeading className={classes.heading}>
            <Trans>Logged in</Trans>
          </BoxHeading>
          <div>{user.name}</div>
        </Box>
        <Button
          variant="contained"
          color="primary"
          size={"large"}
          sx={{
            minWidth: { xs: "96px", sm: "136px" },
            px: 0,
          }}
          {...myAccountProps}
        >
          <Trans>My picture sets</Trans>
        </Button>
      </Box>
    </BoxContainer>
  );
};

export default UserLoggedInBox;
